/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * File: CurrencyInput.tsx
 * Author: Austin Robinson
 * Date Created: 3/26/2022
 * Copyright (c) DrivingDoc 2022
 */
// import * as Sentry from '@sentry/react';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Typography } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

import { CoursePeriod } from 'api/hooks/private/periods/GetCoursePeriod.ts';

import getPeriodNumber from 'pages/Admin/LegacyCalendar/util/getPeriodNumber';

import './StudentSearch.css';

function StudentAvatar(props: any) {
  const { color } = props;
  return (
    <Avatar
      {...props}
      variant="square"
      sx={{
        bgcolor: color,
        px: 1.5,
        py: 0,
        // borderRadius: '0px',
      }}
    >
      {/* eslint-disable-next-line react/destructuring-assignment */}
      <Box sx={{ color: '#FFFFFF', fontSize: '0.9rem' }}>{props.label}</Box>
    </Avatar>
  );
}

type PropTypes = {
  calendarEvent: any;
  coursePeriodEnrollment: CoursePeriod['period_enrollments'][number];
  courseType: 'behind_the_wheel' | 'in_person' | 'synchronous_online' | 'fully_online';
  onclickEmptySeat: any;
  onclickStudent: (studentId: string) => void;
  hideFillSeat: boolean | undefined;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function Student(props: PropTypes) {
  const { calendarEvent, coursePeriodEnrollment, courseType, onclickEmptySeat, onclickStudent, hideFillSeat } = props;

  // const registerStudent = () => {
  //   // console.log(`Show Register Modal for ${JSON.stringify(eventInfo.event.toPlainObject(), null, 2)}`);
  //   // showRegisterModal(eventInfo.event.toPlainObject().id);
  // };
  if (!coursePeriodEnrollment.canceled_at) {
    let avatarBackgroundColor: string;
    switch (coursePeriodEnrollment.attendance) {
      case 'present':
        avatarBackgroundColor = '#34C759';
        break;
      case 'absent':
        avatarBackgroundColor = '#FF3B30';
        break;
      case 'no_permit':
        avatarBackgroundColor = '#FF3B30'; // was #FF9500 (orange)
        break;
      default:
        avatarBackgroundColor = '#007AFF';
    }

    return (
      <Chip
        sx={{
          border: '0.2px solid #000000 !important',
          borderRadius: '8px !important',
          backgroundColor: '#FFFFFF !important',
          color: '#000000 !important',
          overflow: 'hidden',
          // maxWidth: '100%',
          // opacity: collected.isDragging ? 0.5 : 1,
          '.MuiChip-label': {
            flexWrap: 'wrap',
          },
          '.MuiChip-avatarSmall': {
            ml: '0px',
            mr: '-4px',
            height: '100%',
          },
          '.MuiChip-clickable&:hover': {
            transform: 'scale(1.05)',
            transition: 'all 400ms cubic-bezier(.56,2.01,.41,.8)',
            backgroundColor: '#FFFFFF',
          },
        }}
        // label={`${coursePeriodEnrollment.student.user.first_name} ${coursePeriodEnrollment.student.user.last_name ?? ''}`}
        label={
          <Box display="flex" alignItems="center">
            {courseType === 'behind_the_wheel' &&
              coursePeriodEnrollment?.enrollment_type === 'performance_and_observation' && (
                <DriveEtaIcon fontSize="medium" />
              )}
            {courseType === 'behind_the_wheel' && coursePeriodEnrollment?.enrollment_type === 'observation_only' && (
              <VisibilityIcon fontSize="medium" />
            )}
            <Typography ml={courseType === 'behind_the_wheel' ? 0.5 : 0}>
              {`${coursePeriodEnrollment.student.user.first_name} ${coursePeriodEnrollment.student.user.last_name ?? ''}`}
            </Typography>
          </Box>
        }
        avatar={
          <StudentAvatar
            label={getPeriodNumber(
              coursePeriodEnrollment.course_period_id,
              coursePeriodEnrollment.student.period_enrollments,
            )}
            color={avatarBackgroundColor}
          />
        }
        variant="outlined"
        size="small"
        onClick={(event: any) => {
          event.preventDefault();
          onclickStudent(coursePeriodEnrollment.student.user_id);
        }}
      // onDelete={() => {
      //   alert('Remove Student From Drive');
      // }}
      />
    );
  }

  if (hideFillSeat) {
    return null;
  }

  return (
    <Chip
      sx={{
        border: '0.2px solid #000000',
        borderRadius: 2,
        backgroundColor: '#FFFFFF',
        overflow: 'hidden',
        '.MuiChip-avatarSmall': {
          ml: '0px',
          mr: '-4px',
          // width: '22px',
          height: '100%',
          // fontSize: '0.625rem',
        },
        '.MuiChip-clickable&:hover': {
          transform: 'scale(1.05)',
          transition: 'all 400ms cubic-bezier(.56,2.01,.41,.8)',
          backgroundColor: '#FFFFFF',
        },
      }}
      icon={<EditIcon />}
      label="Fill Seat"
      variant="outlined"
      size="small"
      onClick={() => onclickEmptySeat(calendarEvent)}
    />
  );
}
